import { oz } from '@weft/utils';

const nullToUndefined = oz.literal(null).transform(() => undefined);

export function withNullAsOptional<Schema extends oz.ZodTypeAny>(schema: Schema) {
  return schema.optional().or(nullToUndefined);
}
